
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'CategoryIcon',
  props: {
    categoryId: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      required: false,
      default: 16
    }
  },

  data() {
    return {
      currentExtensionIndex: 0,
      extensions: ['svg', 'png', 'webp']
    };
  },

  watch: {
    categoryId() {
      // Reset dell'indice quando cambia la categoryId
      this.currentExtensionIndex = 0;
    }
  },

  methods: {
    getIconPath(categoryId: string) {
      // Controlla se ha icon_id (sport dallo store) o solo icon (sport di fallback/sottomenu)
      if (categoryId) {
        return (
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/categories/square_flags_category/${categoryId}.svg`
        );
      } else {
        // Fallback generico
        return (
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/categories/square_flags_category/3467550448.svg`
        ); // tennis
      }
    },
    handleImageError(event: any) {
      const categoryId = this.categoryId || '3467550448';
      const currentExtension = this.extensions[this.currentExtensionIndex];

      // Prova la prossima estensione disponibile
      if (this.currentExtensionIndex < this.extensions.length - 1) {
        this.currentExtensionIndex++;
        const nextExtension = this.extensions[this.currentExtensionIndex];
        event.target.src =
          process.env.VUE_APP_URL_CLOUDFRONT +
          `/svg/categories/square_flags_category/${categoryId}.${nextExtension}`;
      }
    }
  }
});
